export default {
  skinParamsToIgnore: () => {
    return ['bg-scrl'];
  },
};
